import { createRouter, createWebHistory } from 'vue-router'
//import { jwtDecode } from 'jwt-decode';
//import HomeView from '../views/HomeView.vue'
import AppLogin from '../components/login.vue';
import AppRegister from '../components/register.vue';
import prodocutlist from '../components/prodocutlist.vue';
import AppCart from '../components/cart.vue';
import UserOrder from '../components/UserOrder.vue';
import ChartIndex from '@/components/dashboard/DashboardIndex.vue';
import AppTest from '../components/test.vue';
import ProductMgmt from '../components/ProductMgmt.vue';
//import { useUserLoginStore } from '@/store/Storelogin';
//const useUserLogin = useUserLoginStore();

const routes = [
  {
    path: '/',
    name: 'Home',
    component: AppLogin
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/login',
    name: 'login',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: AppLogin
  },
  {
    path: '/register',
    name: 'register',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: AppRegister
  },
  {
    path: '/product',
    name: 'product',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: prodocutlist,

  },
  {
    path: '/cart',
    name: 'cart',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: AppCart,

  },
  {
    path: '/userorder',
    name: 'userorder',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: UserOrder,

  },
  {
    path: '/chart',
    name: 'chart',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: ChartIndex,    

  },
  {
    path: '/ProductMgmt',
    name: 'ProductMgmt',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: ProductMgmt,

  },
  {
    path: '/test',
    name: 'test',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: AppTest
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  //history: createWebHistory(),
  routes
})
/*
router.beforeEach((to, from, next) => {
  const useStoreUserType = useUserLogin.usertype;
  console.log(useStoreUserType);

  if (to.meta.requiresAuth) {
    const token = localStorage.getItem('RefreshToken');
    
    if (!token) {
      return next('/login');
    }

    try {
      const decoded = jwtDecode(token);
      console.log('解碼後的 Token 內容：', decoded);
      const userRole = decoded.user_accounttype; 

      if (to.meta.roles && !to.meta.roles.includes(userRole)) {
        console.log(`權限不足！此路由需要 ${to.meta.roles}，但用戶是 ${userRole}`);
        next('/'); 
      } else {
        console.log('135')
        console.log(userRole);
        next(); 
      }
    } catch (error) {
      console.error('Token 解析失敗（可能損壞或格式錯誤）：', error);
      next('/login');
    }
  } else {
    next();
  }
});
*/

export default router
